import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, FileText, XCircle } from 'lucide-react';

export default function PaymentFailed() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order');

  return <main className="min-h-screen bg-black px-4 pb-20 pt-28 text-white">
    <section className="mx-auto max-w-xl rounded-2xl border border-zinc-800 bg-zinc-900 p-7 text-center sm:p-10">
      <XCircle className="mx-auto h-20 w-20 text-red-400"/><h1 className="mt-6 text-3xl font-bold">Payment not completed</h1>
      <p className="mt-4 text-gray-300">The payment window did not complete successfully. No browser redirect can activate course access.</p>
      {orderId && <p className="mt-3 break-all text-sm text-gray-500">Order reference: {orderId}</p>}
      <div className="mt-7 grid gap-3 sm:grid-cols-2">
        <Link to="/account/commerce" className="flex items-center justify-center gap-2 rounded-lg bg-yellow-400 px-5 py-3 font-semibold text-black"><FileText className="h-5 w-5"/>Review orders</Link>
        <Link to="/courses" className="flex items-center justify-center gap-2 rounded-lg bg-zinc-800 px-5 py-3 font-semibold"><ArrowLeft className="h-5 w-5"/>Back to courses</Link>
      </div>
      <div className="mt-8 rounded-xl bg-black p-5 text-left"><h2 className="font-semibold">Before trying again</h2><p className="mt-2 text-sm text-gray-400">Check your order history first. If an order is pending, wait for server confirmation so you do not create an unnecessary second payment.</p></div>
    </section>
  </main>;
}
